var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-spot-group-dark"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spot-group-dark",
    clipPath: "url(#clip-spot-group-dark)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M76,186.218a8.474,8.474,0,0,1-5.114-1.721c-4.209-3.154-10.795-8.335-18.27-15.1a232.37,232.37,0,0,1-23.568-24.546,150.067,150.067,0,0,1-20.37-31.6,98.832,98.832,0,0,1-6.331-17.7A77.184,77.184,0,0,1,0,76.987,77.651,77.651,0,0,1,12.769,34.274a76.517,76.517,0,0,1,21.066-21.34,75.257,75.257,0,0,1,84.33,0,76.515,76.515,0,0,1,21.066,21.34,76.869,76.869,0,0,1,10.422,61.277,98.829,98.829,0,0,1-6.331,17.7,150.066,150.066,0,0,1-20.37,31.6,232.369,232.369,0,0,1-23.568,24.546c-7.475,6.768-14.061,11.949-18.27,15.1A8.475,8.475,0,0,1,76,186.218Zm.295-152.457a39.153,39.153,0,0,0-15.479,3.159,39.635,39.635,0,0,0-6.755,3.706,40.391,40.391,0,0,0,0,66.667A39.638,39.638,0,0,0,60.815,111a39.5,39.5,0,0,0,30.958,0,39.638,39.638,0,0,0,6.755-3.706,40.391,40.391,0,0,0,0-66.667,39.636,39.636,0,0,0-6.755-3.706A39.153,39.153,0,0,0,76.295,33.762Z",
    transform: "translate(24 6.891)",
    fill: "#2d3040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotGroup);
export default __webpack_public_path__ + "static/media/spot-group.1f24a688bcd5ee0a0434bf8275123f95.svg";
export { ForwardRef as ReactComponent };